import { formatDistanceStrict } from 'date-fns'
import { OtaHealth, type MobileOtaUpdate } from '@numeo/types-main-mobile'

export const OTA_WORKFLOW_URL = 'https://github.com/numeo-ai/numeo/actions/workflows/mobile-app-ota.yml'

export const HEALTH_CHIP: Record<OtaHealth, { label: string; color: 'success' | 'warning' | 'danger' }> = {
    [OtaHealth.OK]: { label: 'OK', color: 'success' },
    [OtaHealth.WATCH]: { label: 'Watch', color: 'warning' },
    [OtaHealth.BAD]: { label: 'Bad', color: 'danger' },
}

export const HEALTH_RULE =
    'Bad: 3+ rollbacks that are 2%+ of the devices that started it, or every device that started it rolled back. Watch: 1%+ rolled back, or 5%+ of downloads failed. A rollback is a launch that ended before the first screen: a crash, or iOS or the user closing the app early. About 0.5% of iOS launches do this on a healthy update.'

export const ago = (iso: string, now: number) => formatDistanceStrict(new Date(iso), now, { addSuffix: true })

export const percent = (value: number | null) => (value === null ? '—' : `${(value * 100).toFixed(value > 0 && value < 0.1 ? 1 : 0)}%`)

export const shortId = (id: string | null) => (id ? id.slice(0, 8) : '—')

/** The update each app version's devices get now: the newest enabled one (the list is newest first). */
export function liveReleaseIds(items: readonly MobileOtaUpdate[]): Set<string> {
    const seenVersions = new Set<string | null>()
    const live = new Set<string>()
    for (const update of items) {
        if (!update.enabled || seenVersions.has(update.appVersion)) continue
        seenVersions.add(update.appVersion)
        live.add(update.releaseId)
    }
    return live
}

const FAILURE_STAGES: Record<string, string> = { check: 'Update check', download: 'Download', install: 'Install', launch: 'Launch' }

export const failureStageLabel = (stage: string) => FAILURE_STAGES[stage] ?? stage
